import {
  DebouncedDateInput,
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  useFieldLabel,
} from "ra-friendsofbabba";
import { email, maxLength, minLength } from "react-admin";

import React from "react";
import useFormPermission from "../useFormPermission";

const LrInput = (props) => {
  const fieldLabel = useFieldLabel({ ...props });
  const hasFormPermission = useFormPermission(["admin", "region"]);

  return (
    <Group wrapper {...props}>
      <GroupTitle title={fieldLabel(props.source)} />

      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_name"
            maxLength={100}
            disabled={!hasFormPermission("lr_name")}
          />
        </GroupItem>

        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_surname"
            maxLength={100}
            disabled={!hasFormPermission("lr_surname")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedDateInput
            source="lr_birth_date"
            disabled={!hasFormPermission("lr_birth_date")}
          />
        </GroupItem>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_birth_place"
            maxLength={100}
            disabled={!hasFormPermission("lr_birth_place")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_birth_province"
            maxLength={2}
            disabled={!hasFormPermission("lr_birth_province")}
          />
        </GroupItem>

        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_fiscal_code"
            maxLength={16}
            validate={[minLength(16), maxLength(16)]}
            disabled={!hasFormPermission("lr_fiscal_code")}
          />
        </GroupItem>
      </Group>

      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_email"
            maxLength={250}
            type="email"
            validate={[email()]}
            disabled={!hasFormPermission("lr_email")}
          />
        </GroupItem>

        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_pec"
            maxLength={250}
            type="email"
            validate={email()}
            disabled={!hasFormPermission("lr_pec")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="lr_phone"
            maxLength={250}
            type="tel"
            disabled={!hasFormPermission("lr_phone")}
          />
        </GroupItem>
      </Group>
    </Group>
  );
};
export default LrInput;
